import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { selectionIsConfirmable as selectionIsConfirmableSelector } from '../../selectors/reservationModuleState/reservationSelection';
import { getCheckedReservationIds } from '../../selectors';
import { formCardFactory } from '../formCardFactory';
import { initializeStateTab, fetchCurrentEnterpriseCheckedReservations } from '../../actions/actions';
import { RESERVATION_ORDER_ITEMS_EXTENT } from '../../constants';
import { ReservationModuleConfirmationForm } from './ConfirmationForm';

const ReservationConfirmationFormCardElement = formCardFactory({
    FormElement: ReservationModuleConfirmationForm,
    titleTextKey: TextKey.Confirmation,
    dataTestId: 'reservation-confirmation-form',
});
const ReservationConfirmationFormCard = ({ selectionIsConfirmable, ...other }: $TSFixMe) => {
    if (!selectionIsConfirmable) {
        return null;
    }
    return <ReservationConfirmationFormCardElement {...other} />;
};

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        selectionIsConfirmable: selectionIsConfirmableSelector,
        reservationIds: getCheckedReservationIds,
    }),
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    (dispatch, { scope }) => ({
        refetchGroup: async () =>
            Promise.all([
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => Promise<void | [any, any]>' is not assignable to parameter...
                dispatch(initializeStateTab({ scope })),
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
                dispatch(fetchCurrentEnterpriseCheckedReservations({ scope, extent: RESERVATION_ORDER_ITEMS_EXTENT })),
            ]),
    })
)(ReservationConfirmationFormCard);
